/** @module Which picked files may become scans: the photo formats the server decodes. */

export const PHOTO_TYPES = ["image/jpeg", "image/png", "image/webp"] as const;
/** For the file picker; a hint only, "all files" stays one click away on desktops. */
export const PHOTO_ACCEPT = PHOTO_TYPES.join(",");
/** The server refuses anything larger (SCAN_MAX_PHOTO_BYTES). */
export const MAX_PHOTO_BYTES = 25 * 1024 * 1024;

/** Split a picked list into photos we send and files we refuse right away. */
export function splitPhotos(files: File[]): { accepted: File[]; rejected: File[] } {
  const accepted: File[] = [];
  const rejected: File[] = [];
  for (const file of files) {
    const known = (PHOTO_TYPES as readonly string[]).includes(file.type);
    if (known && file.size > 0 && file.size <= MAX_PHOTO_BYTES) accepted.push(file);
    else rejected.push(file);
  }
  return { accepted, rejected };
}
